export default "__VITE_ASSET__B__QooXv__"